export default __webpack_public_path__ + "static/media/02.faa32d24.png";